<form [formGroup]="addressInfoForm">
<div class="row">
  <div class="column">
    <div class="row">
      <mat-form-field appearance="outline" class="column">
        <mat-label>Business Legal Name</mat-label>
        <input formControlName="businessLegalName" matInput>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="outline" class="column">
        <mat-label>Business DBA Name</mat-label>
        <input formControlName="businessDbaName" matInput>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="outline" class="column">
        <mat-label>Website URL</mat-label>
        <input formControlName="webSiteUrl" matInput>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="outline" class="column">
        <mat-label>Business's street address</mat-label>
        <input formControlName="street" matInput required>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="outline" class="column">
        <mat-label>Apt/Unit/Suite</mat-label>
        <input formControlName="aptUnitSuite" matInput>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="outline" class="column">
        <mat-label>City</mat-label>
        <input formControlName="city" matInput required>
      </mat-form-field>
      <mat-form-field appearance="outline" class="column">
        <mat-label>State</mat-label>
        <mat-select formControlName="state" placeholder="State">
          @for (state of states; track state) {
            <mat-option [value]="state.id">{{ state.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="column">
        <mat-label>Zip Code</mat-label>
        <input formControlName="zip" matInput required>
      </mat-form-field>
    </div>
  </div>
  <div class="column">
    <div class="row">
      <mat-form-field appearance="outline" class="column">
        <mat-label>Printed Name / eSignature</mat-label>
        <input formControlName="printedName" matInput>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="outline" class="column">
        <mat-label>Notes</mat-label>
        <textarea formControlName="note" matInput></textarea>
      </mat-form-field>
    </div>
  </div>
</div>
</form>
